import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';

import { UserAvailabilityType } from 'user/model/user-availability.type';

import { CoachSettingsCalendarController } from './coach-settings-calendar.controller';
import {
	CoachSettingsCalendarDay,
	CoachSettingsCalendarSlot,
} from './coach-settings-calendar.model';
import { CoachSettingsCalendarStore } from './coach-settings-calendar.store';

@Component({
	selector: 'spr-coach-settings-calendar',
	templateUrl: './coach-settings-calendar.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [CoachSettingsCalendarStore, CoachSettingsCalendarController],
	host: {
		class: 'flex items-stretch flex-col',
	},
})
export class CoachSettingsCalendarComponent {
	public isSaving$: Observable<boolean>;
	public userAvailability = UserAvailabilityType;
	public availabilityType$: Observable<UserAvailabilityType>;
	public calendarDays$: Observable<CoachSettingsCalendarDay[]>;

	constructor(private _controller: CoachSettingsCalendarController) {
		this.availabilityType$ = _controller.availabilityType$;
		this.calendarDays$ = _controller.calendarDays$;
		this.isSaving$ = _controller.isSaving$;
	}

	public onDaySlotClick(slot: CoachSettingsCalendarSlot) {
		this._controller.toggleDaySlot(slot);
	}

	public onAvailabilityTypeClick(availabilityType: UserAvailabilityType) {
		this._controller.updateAvailabilityType(availabilityType);
	}

	public onUpdateClick() {
		this._controller.updateAvailabilities();
	}
}
